'use es6';

import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { UpIcon, DownIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShowAllLessLink = ({
  isExpanded,
  onClick,
  itemCount
}) => {
  return /*#__PURE__*/_jsx(Link, {
    onClick: onClick,
    "data-test-id": "quick-answers-toggle",
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      children: isExpanded ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: 'reports.collectionHomes.ShowAllLess.seeLess'
        }), /*#__PURE__*/_jsx(IconHolder, {
          icon: UpIcon,
          color: "icon-interactive-default"
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: itemCount ? 'reports.collectionHomes.ShowAllLess.seeAll' : 'reports.collectionHomes.ShowAllLess.seeMore',
          options: {
            count: itemCount ? ` (${itemCount})` : ''
          }
        }), /*#__PURE__*/_jsx(IconHolder, {
          icon: DownIcon,
          color: "icon-interactive-default"
        })]
      })
    })
  });
};
export default ShowAllLessLink;